module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_vizija-ed0b1360a244880cff0127599b3d4b4f.png";